<p-dialog appDialogoPadrao="pi pi-users" descricao="Escolha quem entra no relatório." header="Selecionar Prestadores" [visible]="visible()" (visibleChange)="visible.set($event)" [style]="{ width: '75vw', maxWidth: '900px' }" [closeOnEscape]="true">
    <div class="flex flex-col gap-5">
        <!-- ── Busca rápida + Filtros Avançados ── -->
        <div class="flex flex-col md:flex-row gap-3">
            <div class="relative flex-grow">
                <i class="pi pi-search absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-sm" aria-hidden="true"></i>
                <input
                    type="text"
                    [(ngModel)]="filters.nmPrestador"
                    class="w-full pl-10 pr-4 py-3 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 focus:ring-2 focus:ring-green-500/20 rounded-xl text-sm font-semibold transition-all outline-none"
                    placeholder="Busca rápida por razão social..."
                    aria-label="Busca por razão social do prestador"
                    (keyup.enter)="pesquisar()"
                />
            </div>
            <p-button (click)="toggleFilters()" icon="pi pi-sliders-h" label="Filtros Avançados" [outlined]="filtersOpen()" [text]="!filtersOpen()" class="shrink-0" />
            <p-button (click)="pesquisar()" [loading]="searchLoading()" icon="pi pi-search" label="Pesquisar" class="shrink-0" />
            <p-button [text]="true" severity="secondary" (click)="limparFiltros()" icon="pi pi-eraser" label="Limpar" size="small" class="shrink-0" />
        </div>

        <!-- ── Painel de filtros avançados ── -->
        @if (filtersOpen()) {
            <div class="pt-4 border-t border-slate-100">
                <p-tabs value="0">
                    <p-tablist>
                        <p-tab value="0">Prestador</p-tab>
                        <p-tab value="1">Especialidade</p-tab>
                        <p-tab value="2">R.H.</p-tab>
                        <p-tab value="3">Recursos Materiais</p-tab>
                        <p-tab value="4">Serviços</p-tab>
                        <p-tab value="5">Atividades</p-tab>
                        <p-tab value="6">Histórico</p-tab>
                        <p-tab value="7">Matriz/Filial</p-tab>
                        <p-tab value="8">Outros Filtros</p-tab>
                    </p-tablist>
                    <p-tabpanels>
                        <!-- ── Aba 1: Prestador ── -->
                        <p-tabpanel value="0">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-3">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spNuCrm">Nº CRM</label>
                                    <input
                                        id="spNuCrm"
                                        type="text"
                                        [(ngModel)]="filters.nuCrm"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Ex: 17203"
                                    />
                                </div>
                                <div class="md:col-span-2">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spUf">UF</label>
                                    <p-select inputId="spUf" [(ngModel)]="filters.sgUf" [options]="UF_SELECT_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="UF" />
                                </div>
                                <div class="md:col-span-3">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spCnpj">CNPJ</label>
                                    <input
                                        id="spCnpj"
                                        type="text"
                                        [(ngModel)]="filters.nuCgcPj"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Ex: 12.345.678/0001-90"
                                    />
                                </div>
                                <div class="md:col-span-2">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spRegCad">Tipo</label>
                                    <p-select inputId="spRegCad" [(ngModel)]="filters.regCad" [options]="REG_CAD_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="Tipo de cadastro" />
                                </div>
                                <div class="md:col-span-2">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spSituacaoRegistro">Situação Registro</label>
                                    <p-select
                                        inputId="spSituacaoRegistro"
                                        [(ngModel)]="filters.idSituacaoRegistro"
                                        [options]="SITUACAO_REGISTRO_OPTIONS"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Situação de registro"
                                    />
                                </div>

                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spTipoInscricao">Modo de Inscrição</label>
                                    <p-select
                                        inputId="spTipoInscricao"
                                        [(ngModel)]="filters.idTipoInscricao"
                                        [options]="tiposInscricaoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Modo de inscrição"
                                        [showClear]="true"
                                        (onChange)="onTipoInscricaoChange()"
                                    />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spSituacao">Situação</label>
                                    <p-select
                                        inputId="spSituacao"
                                        [(ngModel)]="filters.idSituacao"
                                        [options]="situacaoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Situação"
                                        [disabled]="!filters.idTipoInscricao"
                                        [showClear]="true"
                                    />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2">Data da Situação</label>
                                    <div class="flex items-center gap-2">
                                        <p-date-picker
                                            [(ngModel)]="filters.dtSituacaoInicio"
                                            inputId="spDtSituacaoInicio"
                                            dateFormat="dd/mm/yy"
                                            dataType="date"
                                            [appendTo]="'body'"
                                            fluid
                                            class="flex-1"
                                            placeholder="De"
                                            [showClear]="true"
                                            ariaLabel="Situação de"
                                        />
                                        <span class="text-[10px] font-bold text-slate-400 shrink-0">até</span>
                                        <p-date-picker
                                            [(ngModel)]="filters.dtSituacaoFim"
                                            inputId="spDtSituacaoFim"
                                            dateFormat="dd/mm/yy"
                                            dataType="date"
                                            [appendTo]="'body'"
                                            fluid
                                            class="flex-1"
                                            placeholder="Até"
                                            [showClear]="true"
                                            ariaLabel="Situação até"
                                        />
                                    </div>
                                </div>

                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spNmPrestador">Razão Social</label>
                                    <input
                                        id="spNmPrestador"
                                        type="text"
                                        [(ngModel)]="filters.nmPrestador"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Razão social do prestador"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spNmFantasia">Nome Fantasia</label>
                                    <input
                                        id="spNmFantasia"
                                        type="text"
                                        [(ngModel)]="filters.nmFantasia"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Nome fantasia"
                                    />
                                </div>

                                <div class="md:col-span-12 flex items-center gap-3 cursor-pointer select-none pt-1">
                                    <p-checkbox [(ngModel)]="filters.emitirApenasComCertificadoVencido" [binary]="true" inputId="spCertificadoVencido" />
                                    <label for="spCertificadoVencido" class="text-xs font-semibold text-slate-600 cursor-pointer"> Emitir apenas com data de validade do Certificado vencida </label>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 2: Especialidade ── -->
                        <p-tabpanel value="1">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spEspecialidade">Especialidade</label>
                                    <p-select
                                        inputId="spEspecialidade"
                                        [(ngModel)]="filters.idEspecialidade"
                                        [options]="especialidadeOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Especialidade"
                                        (onChange)="onEspecialidadeChange()"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spAreaAtuacao">Área de Atuação</label>
                                    <p-select
                                        inputId="spAreaAtuacao"
                                        [(ngModel)]="filters.idAreaAtuacao"
                                        [options]="areaAtuacaoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Área de atuação"
                                        [disabled]="!filters.idEspecialidade"
                                    />
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 3: R.H. ── -->
                        <p-tabpanel value="2">
                            <div class="grid grid-cols-1 gap-4 pt-3">
                                <div>
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spRh">Recursos Humanos</label>
                                    <p-multiSelect
                                        inputId="spRh"
                                        [(ngModel)]="filters.idsRecursoHumano"
                                        [options]="recursosHumanosOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Recursos humanos"
                                        display="chip"
                                        placeholder="Selecione..."
                                    />
                                </div>
                                <div class="flex items-center gap-3">
                                    <p-toggleswitch [(ngModel)]="filters.contemTodosRh" inputId="spContemTodosRh" ariaLabel="Contém todos os recursos humanos selecionados" />
                                    <label for="spContemTodosRh" class="text-xs font-semibold text-slate-600 cursor-pointer"> Contém todos os selecionados (padrão: contém qualquer) </label>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 4: Recursos Materiais ── -->
                        <p-tabpanel value="3">
                            <div class="grid grid-cols-1 gap-4 pt-3">
                                <div>
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spRm">Recursos Materiais</label>
                                    <p-multiSelect
                                        inputId="spRm"
                                        [(ngModel)]="filters.idsRecursoMaterial"
                                        [options]="recursosMateriaisOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Recursos materiais"
                                        display="chip"
                                        placeholder="Selecione..."
                                    />
                                </div>
                                <div class="flex items-center gap-3">
                                    <p-toggleswitch [(ngModel)]="filters.contemTodosRecursoMaterial" inputId="spContemTodosRm" ariaLabel="Contém todos os recursos materiais selecionados" />
                                    <label for="spContemTodosRm" class="text-xs font-semibold text-slate-600 cursor-pointer"> Contém todos os selecionados (padrão: contém qualquer) </label>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 5: Serviços ── -->
                        <p-tabpanel value="4">
                            <div class="grid grid-cols-1 gap-4 pt-3">
                                <div>
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spServicos">Serviços</label>
                                    <p-multiSelect
                                        inputId="spServicos"
                                        [(ngModel)]="filters.idsServico"
                                        [options]="servicosOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Serviços"
                                        display="chip"
                                        placeholder="Selecione..."
                                    />
                                </div>
                                <div class="flex items-center gap-3">
                                    <p-toggleswitch [(ngModel)]="filters.contemTodosServico" inputId="spContemTodosServico" ariaLabel="Contém todos os serviços selecionados" />
                                    <label for="spContemTodosServico" class="text-xs font-semibold text-slate-600 cursor-pointer"> Contém todos os selecionados (padrão: contém qualquer) </label>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 6: Atividades ── -->
                        <p-tabpanel value="5">
                            <div class="grid grid-cols-1 gap-4 pt-3">
                                <div>
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spAtividades">Atividades</label>
                                    <p-multiSelect
                                        inputId="spAtividades"
                                        [(ngModel)]="filters.idsAtividade"
                                        [options]="atividadesOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Atividades"
                                        display="chip"
                                        placeholder="Selecione..."
                                    />
                                </div>
                                <div class="flex items-center gap-3">
                                    <p-toggleswitch [(ngModel)]="filters.contemTodosAtividade" inputId="spContemTodosAtividade" ariaLabel="Contém todas as atividades selecionadas" />
                                    <label for="spContemTodosAtividade" class="text-xs font-semibold text-slate-600 cursor-pointer"> Contém todos os selecionados (padrão: contém qualquer) </label>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 7: Histórico ── -->
                        <p-tabpanel value="6">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spTipoInscricaoHist">Tipo de Inscrição (Histórico)</label>
                                    <p-select
                                        inputId="spTipoInscricaoHist"
                                        [ngModel]="idTipoInscricaoHistorico()"
                                        (ngModelChange)="idTipoInscricaoHistorico.set($event); onTipoInscricaoHistoricoChange()"
                                        [options]="tiposInscricaoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Tipo de inscrição (histórico)"
                                        [showClear]="true"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spSituacaoHist">Situação (Histórico)</label>
                                    <p-select
                                        inputId="spSituacaoHist"
                                        [(ngModel)]="filters.idSituacaoHistorico"
                                        [options]="situacaoHistoricoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Situação (histórico)"
                                        [disabled]="!idTipoInscricaoHistorico()"
                                        [showClear]="true"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2">Data da Situação (Histórico)</label>
                                    <div class="flex items-center gap-2">
                                        <p-date-picker
                                            [(ngModel)]="filters.dtHistoricoInicio"
                                            inputId="spDtHistInicio"
                                            dateFormat="dd/mm/yy"
                                            dataType="date"
                                            [appendTo]="'body'"
                                            fluid
                                            class="flex-1"
                                            placeholder="De"
                                            [showClear]="true"
                                            ariaLabel="Situação histórica de"
                                        />
                                        <span class="text-[10px] font-bold text-slate-400 shrink-0">até</span>
                                        <p-date-picker
                                            [(ngModel)]="filters.dtHistoricoFim"
                                            inputId="spDtHistFim"
                                            dateFormat="dd/mm/yy"
                                            dataType="date"
                                            [appendTo]="'body'"
                                            fluid
                                            class="flex-1"
                                            placeholder="Até"
                                            [showClear]="true"
                                            ariaLabel="Situação histórica até"
                                        />
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 8: Matriz/Filial ── -->
                        <p-tabpanel value="7">
                            <div class="grid grid-cols-2 md:grid-cols-3 gap-3 pt-3">
                                @for (opcao of TIPO_ESTABELECIMENTO_OPTIONS; track opcao.value) {
                                    <div class="flex items-center gap-2">
                                        <p-radioButton [inputId]="'spTipoEstab' + opcao.value" name="tipoEstabelecimento" [value]="opcao.value" [(ngModel)]="filters.tipoEstabelecimento" />
                                        <label [for]="'spTipoEstab' + opcao.value" class="text-xs font-semibold text-slate-600 cursor-pointer">
                                            {{ opcao.label }}
                                        </label>
                                    </div>
                                }
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 9: Outros Filtros ── -->
                        <p-tabpanel value="8">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spClassificacao">Classificação</label>
                                    <p-select
                                        inputId="spClassificacao"
                                        [(ngModel)]="filters.idClassificacaoOpcao"
                                        [options]="classificacaoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Classificação"
                                        [showClear]="true"
                                    />
                                </div>
                                <div class="md:col-span-3">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spTipoGestao">Tipo Gestão</label>
                                    <p-select inputId="spTipoGestao" [(ngModel)]="filters.tipoGestao" [options]="TIPO_GESTAO_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="Tipo de gestão" />
                                </div>
                                <div class="md:col-span-3">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2">Inscrição</label>
                                    <div class="flex items-center gap-2">
                                        <p-date-picker
                                            [(ngModel)]="filters.dtInscricaoInicio"
                                            inputId="spDtInscricaoInicio"
                                            dateFormat="dd/mm/yy"
                                            dataType="date"
                                            [appendTo]="'body'"
                                            fluid
                                            class="flex-1"
                                            placeholder="De"
                                            [showClear]="true"
                                            ariaLabel="Inscrição de"
                                        />
                                        <p-date-picker
                                            [(ngModel)]="filters.dtInscricaoFim"
                                            inputId="spDtInscricaoFim"
                                            dateFormat="dd/mm/yy"
                                            dataType="date"
                                            [appendTo]="'body'"
                                            fluid
                                            class="flex-1"
                                            placeholder="Até"
                                            [showClear]="true"
                                            ariaLabel="Inscrição até"
                                        />
                                    </div>
                                </div>

                                <div class="md:col-span-12 pt-2 border-t border-slate-100">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2">Tipo de Seleção</label>
                                    <div class="flex items-center gap-4 mb-3">
                                        <div class="flex items-center gap-2">
                                            <p-radioButton inputId="spLocalMunicipio" name="localAbrangencia" value="municipio" [(ngModel)]="localAbrangencia" (onClick)="onLocalAbrangenciaChange()" />
                                            <label for="spLocalMunicipio" class="text-xs font-semibold text-slate-600 cursor-pointer">Município</label>
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <p-radioButton inputId="spLocalDelegacia" name="localAbrangencia" value="delegacia" [(ngModel)]="localAbrangencia" (onClick)="onLocalAbrangenciaChange()" />
                                            <label for="spLocalDelegacia" class="text-xs font-semibold text-slate-600 cursor-pointer">Abrangência (Delegacia)</label>
                                        </div>
                                    </div>

                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div class="flex items-end gap-2">
                                            <div class="flex-1">
                                                <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spMunicipio">Município</label>
                                                <input
                                                    pInputText
                                                    id="spMunicipio"
                                                    type="text"
                                                    [ngModel]="municipioLabel()"
                                                    readonly
                                                    [disabled]="localAbrangencia() !== 'municipio'"
                                                    class="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-semibold outline-none"
                                                    placeholder="Nenhum município selecionado"
                                                    aria-label="Município selecionado"
                                                />
                                            </div>
                                            <p-button icon="pi pi-search" [text]="true" ariaLabel="Buscar município" [disabled]="localAbrangencia() !== 'municipio'" (click)="municipioDialogVisible.set(true)" />
                                            <p-button icon="pi pi-times" [text]="true" severity="danger" ariaLabel="Remover município" [disabled]="localAbrangencia() !== 'municipio' || !filters.idMunicipio" (click)="limparMunicipio()" />
                                        </div>
                                        <div class="flex items-end gap-2">
                                            <div class="flex-1">
                                                <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spDelegacia">Delegacia</label>
                                                <input
                                                    pInputText
                                                    id="spDelegacia"
                                                    type="text"
                                                    [ngModel]="delegaciaLabel()"
                                                    readonly
                                                    [disabled]="localAbrangencia() !== 'delegacia'"
                                                    class="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-semibold outline-none"
                                                    placeholder="Nenhuma delegacia selecionada"
                                                    aria-label="Delegacia selecionada"
                                                />
                                            </div>
                                            <p-button icon="pi pi-search" [text]="true" ariaLabel="Buscar delegacia" [disabled]="localAbrangencia() !== 'delegacia' || !filters.sgUf" (click)="delegaciaDialogVisible.set(true)" />
                                            <p-button icon="pi pi-times" [text]="true" severity="danger" ariaLabel="Remover delegacia" [disabled]="localAbrangencia() !== 'delegacia' || !filters.idOrgaoDelegacia" (click)="limparDelegacia()" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </div>
        }

        <!-- ── Lista de resultados ── -->
        <div>
            <div class="flex items-center justify-between mb-3">
                <span class="text-xs font-bold text-slate-500">
                    @if (searched()) {
                        {{ prestadoresList().length }} resultado(s)
                    } @else {
                        Pesquise para listar prestadores
                    }
                </span>
                <div class="flex items-center gap-2">
                    @if (prestadoresList().length > 0) {
                        <p-button [text]="true" size="small" (click)="selecionarTodos()" icon="pi pi-check-square" label="Marcar Todos" />
                    }
                    @if (totalSelecionados() > 0) {
                        <span class="text-xs font-bold bg-green-100 text-green-800 px-2.5 py-0.5 rounded-full border border-green-200"> {{ totalSelecionados() }} selecionado(s) </span>
                        <p-button [text]="true" severity="danger" size="small" (click)="desmarcarTodos()" icon="pi pi-times" label="Desmarcar" />
                    }
                </div>
            </div>

            @if (searchLoading()) {
                <div class="border border-slate-200 rounded-xl overflow-hidden">
                    @for (i of [1, 2, 3, 4, 5]; track i) {
                        <div class="flex items-center gap-3 px-3 py-2.5 border-b border-slate-100 animate-pulse last:border-b-0">
                            <div class="w-4 h-4 bg-slate-200 rounded shrink-0"></div>
                            <div class="flex-grow space-y-1.5">
                                <div class="h-3 bg-slate-200 rounded w-2/3"></div>
                                <div class="h-2 bg-slate-100 rounded w-1/3"></div>
                            </div>
                            <div class="h-4 w-16 bg-slate-200 rounded shrink-0"></div>
                        </div>
                    }
                </div>
            } @else if (!searched()) {
                <div class="py-8 text-center space-y-2">
                    <i class="pi pi-search text-4xl text-slate-200 block" aria-hidden="true"></i>
                    <p class="text-xs font-semibold text-slate-400">Use os filtros acima e clique em "Pesquisar".</p>
                </div>
            } @else if (prestadoresList().length === 0) {
                <div class="py-8 text-center space-y-2">
                    <i class="pi pi-building text-4xl text-slate-200 block" aria-hidden="true"></i>
                    <p class="text-xs font-semibold text-slate-400">Nenhum prestador encontrado.</p>
                </div>
            } @else {
                <p-table [value]="prestadoresList()" stripedRows [scrollable]="true" scrollHeight="220px" [ariaLabel]="'Resultados da pesquisa de prestadores'">
                    <ng-template pTemplate="body" let-prestador>
                        <tr>
                            <td style="width: 3rem">
                                <p-checkbox [binary]="true" [ngModel]="isSelecionado(prestador)" (onChange)="toggleSelecionado(prestador)" [ariaLabel]="'Selecionar ' + prestador.nmPrestador" />
                            </td>
                            <td class="cursor-pointer" (click)="toggleSelecionado(prestador)">
                                <span class="text-xs font-bold block leading-tight">{{ prestador.nmPrestador | titlecase }}</span>
                                <span class="text-[10px] text-color-secondary"> {{ prestador.nuCrm }}/{{ prestador.sgUf }} · {{ prestador.nuCgcPj }} </span>
                            </td>
                            <td style="width: 9rem" class="text-right">
                                <span class="situacao-badge" [class]="'situacao-badge--' + situacaoSeveridade(prestador.dsSituacao)">
                                    {{ prestador.dsSituacao }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" [text]="true" severity="secondary" (click)="cancelar()" />
        <p-button label="Adicionar à Fila" icon="pi pi-check" [disabled]="totalSelecionados() === 0" (click)="confirmar()" />
    </ng-template>
</p-dialog>

<app-pesquisa-municipio [(visible)]="municipioDialogVisible" (confirmado)="selecionarMunicipio($event)" />
<app-pesquisa-delegacia [(visible)]="delegaciaDialogVisible" [uf]="filters.sgUf" (confirmado)="selecionarDelegacia($event)" />
